/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA 02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 *
 */

import request, { getEndpointUrl } from '@/core/apiRequest/apiRequest';
import config from '@/config';

export const getEntities = () =>
    request(
        getEndpointUrl('entitiesList'),
        {
            method: 'GET'
        },
        {},
        config.baseUrls.portal
    );

export const getEntity = entityId =>
    request(
        getEndpointUrl('entity', { entityId }),
        {
            method: 'GET'
        },
        {},
        config.baseUrls.portal
    );

export const getView = viewId =>
    request(
        getEndpointUrl('searchView', { viewId }),
        {
            method: 'GET'
        },
        {},
        config.baseUrls.portal
    );

export const getViews = () =>
    request(
        getEndpointUrl('searchViews'),
        {
            method: 'GET'
        },
        {},
        config.baseUrls.portal
    );

export const getEntityTableData = ({ entityId, body }) =>
    request(
        getEndpointUrl('entityTableData', { entityId }),
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        },
        {},
        config.baseUrls.portal
    );

export const getEntityData = ({ entityId, body = {} }) =>
    request(
        getEndpointUrl('entityData', { entityId }),
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        },
        {},
        config.baseUrls.portal
    );

export const startCsvData = ({ entityId, body = {} }) =>
    request(
        getEndpointUrl('entityCsvData', { entityId }),
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        },
        {},
        config.baseUrls.portal
    );

export const createView = ({ body }) =>
    request(
        getEndpointUrl('view'),
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        },
        {},
        config.baseUrls.portal
    );

export const deleteView = viewId =>
    request(
        getEndpointUrl('viewId', { viewId }),
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        {},
        config.baseUrls.portal
    );
